import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface ToggleSectionLayoutProps {
  sectionOne: React.ReactNode;
  sectionTwo: React.ReactNode;
  labelOne: string;
  labelTwo: string;
  defaultSection?: 'one' | 'two';
}

const ToggleSectionLayout: React.FC<ToggleSectionLayoutProps> = ({
  sectionOne,
  sectionTwo,
  labelOne,
  labelTwo,
  defaultSection = 'one',
}) => {
  const [active, setActive] = useState<'one' | 'two'>(defaultSection);

  const tabButtonClasses = (isActive: boolean) =>
    `relative rounded-md py-2 px-4 text-sm font-medium transition-colors md:text-base
    ${isActive ? 'text-primary font-semibold' : 'text-gray-600 hover:text-primary'}`;

  return (
    <>
      {/* Tabs (parte superior) */}
      <div className="w-full flex gap-3 border-b border-stroke bg-white px-6 pt-6 dark:border-strokedark dark:bg-boxdark">
        {[labelOne, labelTwo].map((label, i) => {
          const isActive = active === (i === 0 ? 'one' : 'two');
          return (
            <button
              key={label}
              onClick={() => setActive(i === 0 ? 'one' : 'two')}
              className={tabButtonClasses(isActive)}
            >
              {label}
              {isActive && (
                <motion.div
                  layoutId="underline"
                  className="absolute bottom-0 left-0 right-0 h-[3px] bg-primary rounded-full"
                  transition={{ duration: 0.3 }}
                />
              )}
            </button>
          );
        })}
      </div>

      {/* Sección activa, alineada con la parte superior */}
      <div className="w-full">
        <AnimatePresence mode="wait">
          {active === 'one' ? (
            <motion.div
              key="sectionOne"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.25 }}
            >
              {sectionOne}
            </motion.div>
          ) : (
            <motion.div
              key="sectionTwo"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.25 }}
            >
              {sectionTwo}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default ToggleSectionLayout;
